import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

/** Stripe product name for the web subscription tier (Puzzle Premium). */
const PUZZLE_SUBSCRIPTION_PRODUCT_NAME = "Puzzle Premium";

const StripeProductService = {
    /**
     * Get Stripe products
     * @returns {Promise<Object>} Products response with products array and count
     */
    getProducts: async () => {
        try {
            const response = await ApiService.getData("/home/stripe/products");
            
            if (response && response.code === "FAILURE") {
                throw new Error(response.message || "Failed to fetch products");
            }
            
            return response;
        } catch (error) {
            Logger.error("Error fetching products:", error);
            throw error;
        }
    },

    /**
     * Get the puzzle subscription product (Puzzle Premium) with its prices.
     * Filters out free prices (unit_amount === 0)
     * @returns {Promise<Object|null>} Product object with prices array, or null if not found
     */
    getPuzzleSubscriptionProduct: async () => {
        try {
            const response = await StripeProductService.getProducts();
            
            if (!response || !response.products || !Array.isArray(response.products)) {
                return null;
            }
            
            const puzzleProduct = response.products.find(product => {
                const productName = product.payload?.name || product.name || "";
                return productName === PUZZLE_SUBSCRIPTION_PRODUCT_NAME;
            });
            
            if (!puzzleProduct) {
                return null;
            }
            
            // Filter out free plans (0 price) from prices
            if (puzzleProduct.prices && Array.isArray(puzzleProduct.prices)) {
                puzzleProduct.prices = puzzleProduct.prices.filter(price => {
                    const payload = price.payload || {};
                    const unitAmount = payload.unit_amount || 0;
                    // Filter out free plans (unitAmount === 0)
                    return unitAmount > 0;
                });
            }
            
            return puzzleProduct;
        } catch (error) {
            Logger.error("Error fetching puzzle subscription product:", error);
            throw error;
        }
    }
};

export default StripeProductService;

